type GraphQLErrorLike = {
  message?: string
  extensions?: {
    code?: string
  } | null
}

const isGraphQLErrorLike = (value: unknown): value is GraphQLErrorLike => {
  return typeof value === 'object' && value !== null
}

const toGraphQLErrorList = (value: unknown): GraphQLErrorLike[] => {
  if (!Array.isArray(value)) return []
  return value.filter(isGraphQLErrorLike)
}

export const getGraphQLErrors = (error: unknown): GraphQLErrorLike[] => {
  if (typeof error !== 'object' || error === null) return []

  if ('graphQLErrors' in error) {
    return toGraphQLErrorList(error.graphQLErrors)
  }

  if ('errors' in error) {
    return toGraphQLErrorList(error.errors)
  }

  return []
}

export const getFirstGraphQLError = (error: unknown): GraphQLErrorLike | undefined => {
  return getGraphQLErrors(error)[0]
}
